import { IEirSalesViewAvailableAppointments } from "@modules/eirSalesFacade/interfaces/models/IEirSalesViewAvailableAppointments";
import { mapEirSalesViewAvailableAppointmentsResponse } from "@modules/eirSalesFacade/mappers/mapEirSalesViewAvailableAppointmentsResponse";
import { fetcher } from "@utils/fetcher";
import { IFetchOptions } from "itsf-ui-common";
import { viewAvailableAppointmentsRoute } from "@api-routes/eirSalesFacade";

export const getViewAvailableAppointments = (prospectReference: string, offerId: number, options: IFetchOptions = {}) =>
    fetcher<IEirSalesViewAvailableAppointments>(viewAvailableAppointmentsRoute(prospectReference, offerId), {
        mapper: mapEirSalesViewAvailableAppointmentsResponse,
        ...options,
    });
